import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/designates',
    name: 'designates',
    component: () => import('../views/designates.vue')
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('../views/forget.vue')
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/list.vue')
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/details.vue')
  },
  {
    path: '/car',
    name: 'car',
    component: () => import('../views/car.vue')
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: () => import('../views/confirm.vue')
  },
  {
    path: '/submitOrder',
    name: 'submitOrder',
    component: () => import('../views/submitOrder.vue')
  },
  {
    path: '/newsList',
    name: 'newsList',
    component: () => import('../views/newsList.vue')
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('../views/newsDetail.vue')
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/mine.vue')
  },
  {
    path: '/order_item',
    name: 'order_item',
    component: () => import('../views/order_item.vue')
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('../views/info.vue')
  },
  {
    path: '/password',
    name: 'password',
    component: () => import('../views/password.vue')
  },
  {
    path: '/collect',
    name: 'collect',
    component: () => import('../views/collect.vue')
  },
  {
    path: '/InvoiceList',
    name: 'InvoiceList',
    component: () => import('../views/InvoiceList.vue')
  },
  {
    path: '/AddressList',
    name: 'AddressList',
    component: () => import('../views/AddressList.vue')
  },
  {
    path: '/footPage',
    name: 'footPage',
    component: () => import('../views/footPage.vue')
  },
  {
    path: '/our',
    name: 'our',
    component: () => import('../views/our.vue')
  },
  {
    path: '/mycoupon',
    name: 'mycoupon',
    component: () => import('../views/mycoupon.vue')
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: () => import('../views/coupon.vue')
  },
  {
    path: '/couponDet',
    name: 'couponDet',
    component: () => import('../views/couponDet.vue')
  },
]

const router = new VueRouter({
  // mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  // base: '/',
  routes
})
const changePush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return changePush.call(this, location).catch(err => err);
}

export default router
